/**
 * 온라인(다른 기기) 실시간 전송 공급자 선택.
 *   REACT_APP_REALTIME_PROVIDER = 'supabase'(기본) | 'cloudflare'
 *   REACT_APP_REALTIME_WS_URL   = wss://cp-realtime.<account>.workers.dev  (cloudflare 일 때 필수)
 * cloudflare 를 골랐는데 URL 이 없으면 안전하게 supabase 로 동작한다.
 */
export type RealtimeProvider = 'supabase' | 'cloudflare';

const rawProvider = String(process.env.REACT_APP_REALTIME_PROVIDER ?? '').trim().toLowerCase();
const rawWsUrl = String(process.env.REACT_APP_REALTIME_WS_URL ?? '').trim().replace(/\/+$/, '');

export const REALTIME_WS_URL = rawWsUrl;
export const REALTIME_PROVIDER: RealtimeProvider =
  rawProvider === 'cloudflare' && /^wss?:\/\//i.test(rawWsUrl) ? 'cloudflare' : 'supabase';

export const isCloudflareRealtime = () => REALTIME_PROVIDER === 'cloudflare';

/** 소통 프레젠(CommRoom)은 항상 Cloudflare Worker 사용 — 환경변수가 없으면 배포된 Worker 로 폴백 */
export const DEFAULT_COMM_WS_URL = 'wss://cp-realtime.edukodi-classplanner.workers.dev';
export const COMM_WS_URL = /^wss?:\/\//i.test(rawWsUrl) ? rawWsUrl : DEFAULT_COMM_WS_URL;
